import React from 'react';

export type SystemContextProps = {
    systemName: string | null,
    setSystemName: (value: string | null) => void,
    apiVersion: string | null,
    setApiVersion: (value: string | null) => void,
    isOffice: boolean,
    setIsOffice: (value: boolean) => void,
    minAppVersion: string | null,
    setMinAppVersion: (value: string | null) => void,
    appEnabled: boolean,
    setAppEnabled: (value: boolean) => void,
    logoUrl: string | null,
    setLogoUrl: (value: string | null) => void,
    serverTimezoneOffsetMinutes: number | null,
    setServerTimezoneOffsetMinutes: (value: number | null) => void,
    tenantDisplayName: string | null,
    setTenantDisplayName: (value: string | null) => void,
};

const SystemContext: React.Context<SystemContextProps> = React.createContext<SystemContextProps>({
    systemName: null,
    setSystemName: () => {},
    apiVersion: null,
    setApiVersion: () => {},
    isOffice: false,
    setIsOffice: () => {},
    minAppVersion: null,
    setMinAppVersion: () => {},
    appEnabled: false,
    setAppEnabled: () => {},
    logoUrl: null,
    setLogoUrl: () => {},
    serverTimezoneOffsetMinutes: null,
    setServerTimezoneOffsetMinutes: () => {},
    tenantDisplayName: null,
    setTenantDisplayName: () => {},
});

export default SystemContext;